<script setup lang="ts">
import Image from '../../mixit-ui/components/media/Image.vue'
import ImageRemote from '../../mixit-ui/components/media/ImageRemote.vue'
import example from '@/assets/example-media/product-example.png?w=640;1024;1920;3450&format=avif;webp;jpg&as=picture'
import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

type ItemMenuSize = 'sm' | 'md' | 'square';

const { size = 'md', severity = 'white' } = defineProps<{
  label: string;
  imageUri?: string;
  routerTo: RouteLocationRaw
  subTitle?: string;
  size?: ItemMenuSize,
  severity?: 'white' | 'yellow'
}>();

const SIZE_CLASSES: Record<string, { card: string; subtitle: string; image: string; icon: string; }> = {
  square: { card: 'text-xs px-4 py-1 flex-row gap-2 lg:text-sm lg:px-4 lg:py-6 lg:flex-col lg:gap-4 lg:text-center', subtitle: 'text-xs', image: 'w-12 lg:w-22 2xl:w-34', icon: 'lg:hidden' },
  md: { card: 'text-sm px-4 py-2 flex-row gap-2', subtitle: 'text-xs', image: 'w-16', icon: '' },
  sm: { card: 'text-xs px-4 py-1 flex-row gap-2', subtitle: 'text-2xs', image: 'w-12', icon: '' }
};

const severitySwitch = (severity: 'white' | 'yellow'): string => {
  switch (severity) {
    case 'white': return 'bg-white hover:bg-yellow-100'
    case 'yellow': return 'bg-yellow-100 hover:bg-yellow-200'
    default: return 'bg-white hover:bg-yellow-100'
  }
};

const getSizeSet = (size: ItemMenuSize) => { return SIZE_CLASSES[size]; }

const itemSize = computed(() => getSizeSet(size));
const severityColors = computed(() => severitySwitch(severity))
</script>

<template>
  <RouterLink
    :to="routerTo"
    class="rounded-sm flex text-brown-600 font-roboto-slab items-center transition"
    :class="[itemSize.card, severityColors]"
  >
    <ImageRemote
      v-if="imageUri"
      :data="{ uri: `https://img.mix.it/general_assets/categories/${imageUri}` }"
      :class="itemSize.image"
      img-class="w-full"
    />
    <Image
      v-else
      :image="example"
      alt="Example"
      loading="eager"
      fetchpriority="high"
      :class="itemSize.image"
      img-class="w-full"
    />
    <div class="flex flex-col">
      <strong
        v-if="subTitle"
        class="text-brown-400"
        :class="[itemSize.subtitle]"
      >
        {{ subTitle }}
      </strong>
      <strong>{{ label }}</strong>
    </div>
    <i
      class="mi-chevron-r ml-auto text-base"
      :class="itemSize.icon"
    />
  </RouterLink>
</template>
